import React, { useEffect, useState } from 'react';
import Sidebar from '../../Common/Sidebar/Sidebar';
import '../globalStyle.css';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { toast } from "react-toastify";
import AddCategoryPopup from '../../Common/Popup/AddCategoryPopup';
import Modal from 'react-modal';
import axios from 'axios';

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
};

export default function AddMasala() {
    const mainTopic = "Masala";
    const [masalaInfo, setMasalaInfo] = useState({});;
    const [popup, setPopup] = useState(false);

    const [categoryList, setCategoryList] = useState([])

    useEffect( ()  => {     
      async function fetchData() {   
       const category = await axios.get(`https://ahlehaqserver.herokuapp.com/api/category/${mainTopic}`)
       setCategoryList(category.data.response);
      }
      fetchData(); 
    },[popup])


    const saveMasala = async (e) => {
        e.preventDefault();
        try {
           if(masalaInfo.description.length > 0){
            const masalaInserted = await axios.post(
              `https://ahlehaqserver.herokuapp.com/api/masala`,
              masalaInfo
            );
    
            //if request success, will show success notification
            if (masalaInserted.data.code === 200) {
              setMasalaInfo({});
              toast.success("Masala added successfully!");
              e.target.reset();
            }
           }else{
             toast("Please write description")
           }
            
        } catch (error) {
          console.log(error);
          // toast.error("Internal Server Error!");
        }
      };

    return (
        <div>
            <Modal isOpen={popup} style={customStyles}>
                <AddCategoryPopup
                topic={mainTopic}
                setPopup={setPopup}
                />
            </Modal>
            <div className="row">
                <div className="col-md-3">
                   <Sidebar/>
                </div>
                <div className="col-md-9">
                   <h1 className="ml-4">Add New Masala</h1>

                   <form onSubmit={saveMasala}>
                      <div className="row">
                         <div className="col-md-5 col-8">
                          <div className="form-group">
                              <label for="exampleInputEmail1" className="font-weight-bold">
                                Select category<span className="text-danger">*</span>
                              </label>
                              
                              <select
                                className="form-control rounded"
                                id="exampleInputEmail1"
                                name="category"
                                value={masalaInfo?.category || ""}
                                required
                                onChange={(e) =>
                                    setMasalaInfo((prev) => ({
                                    ...prev,
                                    [e.target.name]: e.target.value,
                                  }))
                                }
                              >
                                <option>
                                  {
                                    categoryList.length === 0 ? "Click add button and create new category" :
                                    "Choose from the list"
                                  }
                                </option>
                                {categoryList &&
                                  categoryList.map((data) => (
                                    <option value={data.category}>
                                      {data.category}
                                    </option>
                                  ))}
                              </select>  
                          </div>
                        </div>
                        <div className="col-md-1 col-2 addBtnPadding" >
                            <button
                            type="button"
                            className="btn btn-success addBtn"
                            onClick={() => setPopup(true)}
                            >
                                + Add
                            </button>
                        </div>

                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="exampleInputPassword1" className="font-weight-bold">
                            Masala Title<span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control rounded"
                              placeholder="Write Masala Title"
                              id="exampleInputPassword1"
                              name="title"
                              value={masalaInfo?.title || ""}
                              required
                              onChange={(e) =>
                                setMasalaInfo((prev) => ({
                                  ...prev,
                                  [e.target.name]: e.target.value,
                                }))
                              }
                            />
                          </div>
                         </div>

                          
                         <div className="col-md-12">
                         <div className="form-group">
                              <label for="exampleInputEmail1" className="font-weight-bold">
                                Write question and answer<span className="text-danger">*</span>
                              </label>
                         
                                    <CKEditor
                                        editor={ ClassicEditor }
                                        id="editeur1"
                                        data={masalaInfo?.description || ""}
                                        onChange={ ( event, editor ) => {
                                            const data = editor.getData();
                                            setMasalaInfo((Prev) => ({ ...Prev, description: data }))
                                        } }
                                    />
                            </div>   
                         </div>  
                          
                         <div className="col-md-4">
                            <div className="mt-4 ">
                              <button
                                type="submit"
                                className="btn btn-success rounded-pill px-4 ml-auto"
                              >
                                Done
                              </button>
                            </div>  
                         </div> 

                      </div>

                      
                    </form>
                </div>
            </div>
        </div>
    )
}
